// this component will need to be changed everywhere where used for Row (if possible and logical)
// agirtot - worlist and contactUs
// dynamic-form - {seems there's not much we can do} - SectionalFormRenderer
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { validateNode } from "../helpers";
const FlexRow = (_a) => {
    var { className, items, valign } = _a, props = __rest(_a, ["className", "items", "valign"]);
    const count = items.length >= 3 ? "3" : items.length;
    return (React.createElement("div", Object.assign({ className: classNames("gerudo-flex-row", `columns-${count} valign-${valign}`, className) }, props), items.map((el, i) => (React.createElement("div", { key: `uuid__${i + items.length}` }, validateNode(el, `${el}`))))));
};
FlexRow.defaultProps = {
    items: [],
    valign: "center",
};
FlexRow.propTypes = {
    className: PropTypes.string,
    items: PropTypes.node,
    valign: PropTypes.oneOf(["top", "center", "bottom"]),
};
export default FlexRow;
export { FlexRow };
//# sourceMappingURL=index.js.map